import React, { useState, useEffect } from "react";
import { Button, CircularProgress, IconButton } from "@mui/material";

import { FieldArray, Form, Formik } from "formik";
import Category from "../../../Service/Item-master/itemCategory.service";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import Loading from "../../MUI_components/loading";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Add, Remove } from "@mui/icons-material";

const AddCategory = ({ setOpen, code, setSubmitted, fetchItemCategory, setChildUpdate}) => {
  const dispatch = useDispatch();
  const Validation = yup.object({
    name: yup.string().required(),
    categoryCode:yup.string().required()
  });

  const [initValue, setInitValue] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const getCategory = async () => {
      if (code) {
        try {
          let response = await Category.get(code);
          // converting NULL value into Empty string
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue(response);
        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue({
          name: "",
          categoryCode:"",
          itemSubCategories: [{ name: "" }],
        });
      }
      setIsLoaded(true);
    };

    getCategory();
  }, [code, dispatch]);

  const handleSubmit = async (values) => {
    try {
      if (code) {
       await Category.edit(values, code);
       setSubmitted((prev) => !prev);
       setOpen(false);
      }else {
      const res = await Category.create(values);

      if(res.categogryExiting) {
        alert(res.message);
        return
      }else if(res.codeExisting) {
        alert(res.message);
        return
      }
      setSubmitted((prev) => !prev);
      setOpen(false);
      if (fetchItemCategory) {setChildUpdate();}
      } 
      dispatch(
        openSnackbar(
          true,
          "success",
          `Item Category ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form autoComplete="off">
              <div className="row mt">
                <div className="col-8">
                  <FormControl name="name" label="Category" control="input" />
                </div>
                <div className="col-4">
                  <FormControl name="categoryCode" label="Category Code" control="input" />
                </div>
              </div>
              {/* <div className="row mt">
                <Typography variant="body2"> Subcategory</Typography>
              </div> */}
              <div className="row">
                <FieldArray name="itemSubCategories">
                  {(subcategoryProps) => {
                    const { push, remove, form } = subcategoryProps;
                    const { values } = form;
                    const { itemSubCategories } = values;

                    return (
                      <>
                        {itemSubCategories.map((element, index) => (
                          <div
                            key={index}
                            className="col-12 flex-end"
                            style={{ alignItems: "center" }}
                          >
                            <div style={{ width: "100%" }}>
                              <FormControl
                                label="Subcategory"
                                name={`itemSubCategories[${index}].name`}
                                control="input"
                              />
                            </div>
                            <IconButton onClick={() => remove(index)}>
                              <Remove style={{ color: "red" }} />
                            </IconButton>
                          </div>
                        ))}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <IconButton
                            onClick={() =>
                              push({
                                name: "",
                              })
                            }
                          >
                            <Add />
                          </IconButton>
                        </div>
                      </>
                    );
                  }}
                </FieldArray>
              </div>

              <div className="row flex-end mb">
                <Button
                  type="submit"
                  style={{ marginRight: 5 }}
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting ? true : false}
                  startIcon={
                    isSubmitting && (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                >
                  {code ? "Update" : "Save"}
                </Button>
                <Button
                  onClick={() => setOpen(false)}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default AddCategory;